import { useHttpClient } from '@airship-platform/airship-patterns';
import { useCallback } from 'react';
import { AppointmentProposalOptionModifier } from '../../../data-access/appointmentProposalOptionModifiers';
import { AppointmentProposalOptionProduct } from '../../../data-access/appointmentProposalOptionProducts';
import { AppointmentProposalOption } from '../../../data-access/appointmentProposalOptions';
import { AppointmentProposalOptionSOW } from '../../../data-access/appointmentProposalOptionSows';

const templatePathBuilder = (opts: {
  appointmentId: string;
  appointmentProposalId: string;
  action: 'add-template' | 'append-options';
}) =>
  `/appointment-templates/${opts.appointmentId}/proposals/${opts.appointmentProposalId}/${opts.action}`;

export const useApplyProposalTemplateHttp = () => {
  const httpClient = useHttpClient();

  const addTemplateOptions = useCallback(
    (
      appointmentId: string,
      appointmentProposalId: string,
      payload: {
        proposalTemplateIds: string[];
        optionDefaults: Partial<AppointmentProposalOption>;
      }
    ) =>
      httpClient.post<{
        options: AppointmentProposalOption[];
        products: AppointmentProposalOptionProduct[];
        modifiers: AppointmentProposalOptionModifier[];
        sows: AppointmentProposalOptionSOW[];
      }>(
        templatePathBuilder({
          appointmentId,
          appointmentProposalId,
          action: 'add-template',
        }),
        payload
      ),
    [httpClient]
  );

  const appendTemplateOptions = useCallback(
    (
      appointmentId: string,
      appointmentProposalId: string,
      payload: {
        options: {
          proposalTemplateOptionId: string;
          appointmentProposalOptionId: string;
        }[];
      }
    ) =>
      httpClient.post<{
        products: AppointmentProposalOptionProduct[];
        modifiers: AppointmentProposalOptionModifier[];
        sows: AppointmentProposalOptionSOW[];
      }>(
        templatePathBuilder({
          appointmentId,
          appointmentProposalId,
          action: 'append-options',
        }),
        payload
      ),
    [httpClient]
  );

  return {
    addTemplateOptions,
    appendTemplateOptions,
  };
};
